import { render, staticRenderFns } from "./CardGrid.vue?vue&type=template&id=3bbbb04d&scoped=true&"
import script from "./CardGrid.vue?vue&type=script&lang=js&"
export * from "./CardGrid.vue?vue&type=script&lang=js&"
import style0 from "./CardGrid.vue?vue&type=style&index=0&id=3bbbb04d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbbb04d",
  null
  
)

export default component.exports